<template>
  <div>
    <div
      class="w-screen md:max-w-screen-xl flex-col md:flex-row m-auto flex pt-20 pb-10 px-4"
    >
      <h1>{{ $t('general.titles.faq') }}</h1>
    </div>
    <div v-for="blockData in blocksData" :key="blockData?.id">
      <GenericBlock
        :component-type="blockData.__typename"
        :content="blockData"
      />
    </div>
  </div>
</template>

<script setup>
import { useStrapiPageSeo } from '~/composables/useStrapiPage'

const { locale } = useI18n()
const pageData = await useStrapiPage({
  slug: `faq_${locale.value}`,
  locale: convertLocaleIntoBCP47(locale.value),
})
const blocksData = computed(() => pageData?.data?.value?.pages?.[0]?.contents)
definePageMeta({
  layout: 'default-max-screen',
  preloaderType: 'strapi',
})

useStrapiPageSeo({
  pageData,
})
</script>
